import { connect, mapProps } from '@formily/vue'
import CellItem from './CellItem.vue'

const Cell = connect(
  CellItem,
  mapProps({
    value: 'value', // 添加这行，映射表单值
    readOnly: 'readonly',
  }),
)

export default Cell
